import { v4 as uuidv4 } from 'uuid';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';
import CaseWorklogDTO from './CaseWorklogDTO';

interface CaseDetailDTO {
  id: string;
  caseNumber: string;
  next: string;
  nextComment: string;
  subject: string;
  description: string;
  caseWorklogs: CaseWorklogDTO[];
}
const CaseDetailDTO = {
  create: (initValues?: Partial<CaseDetailDTO>): CaseDetailDTO => {
    const defaults: CaseDetailDTO = {
      id: '',
      caseNumber: '',
      next: '',
      nextComment: '',
      subject: '',
      description: '',
      caseWorklogs: [],
    };
    const fixedInitValues: Partial<CaseDetailDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
        caseWorklogs: ArrayUtil.EasyMap(initValues.caseWorklogs, CaseWorklogDTO.create),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default CaseDetailDTO;